var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 5.83329H9.16699V9.16663H5.83366V10.8333H9.16699V14.1666H10.8337V10.8333H14.167V9.16663H10.8337V5.83329ZM10.0003 1.66663C5.40033 1.66663 1.66699 5.39996 1.66699 9.99996C1.66699 14.6 5.40033 18.3333 10.0003 18.3333C14.6003 18.3333 18.3337 14.6 18.3337 9.99996C18.3337 5.39996 14.6003 1.66663 10.0003 1.66663ZM10.0003 16.6666C6.32533 16.6666 3.33366 13.675 3.33366 9.99996C3.33366 6.32496 6.32533 3.33329 10.0003 3.33329C13.6753 3.33329 16.667 6.32496 16.667 9.99996C16.667 13.675 13.6753 16.6666 10.0003 16.6666Z",
    fill: "#585771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAdd);
export default __webpack_public_path__ + "static/media/circle-add.ca5ff19c92e83b9ef936b59ab79794b4.svg";
export { ForwardRef as ReactComponent };